import { namespace } from "vuex-class";
import store from "@/store";
import { getModule } from "vuex-module-decorators";

import PromotionListModule from "./modules/promotion/PromotionListModule";
import PromotionDetailModule from "./modules/promotion/PromotionDetailModule";
import PromotionConfirmModule from "./modules/promotion/PromotionConfirmModule";
import MallProductListModule from "./modules/mall/MallProductListModule";
import MallOrderListModule from "./modules/mall/MallOrderListModule";
import MallShoppingCartModule from "./modules/mall/MallShoppingCartModule";
import MallAttributeModule from "./modules/mall/MallAttributeModule";
import MallOrderConfirmModule from "./modules/mall/MallOrderConfirmModule";
import MallOrderDetailModule from "./modules/mall/MallOrderDetailModule";
import MallActivityModule from "./modules/mall/MallActivityModule";
import UserModule from "./modules/UserModule";
import DrawModule from "./modules/draw/DrawModule";
import GrowthDetailModule from "./modules/star-level/GrowthDetailModule";
import MallMyCouponModule from "./modules/mall/MallMyCouponModule";
import BountyDetailModule from "./modules/bounty/BountyDetailModule";
import IntegralDetailModule from "./modules/integral/IntegralDetailModule";
import StartLevelCenterModule from "./modules/star-level/StartLevelCenterModule";
import K1PromotionListModule from "./modules/k1-promotion/K1PromotionListModule";
import K1PromotionDetailModule from "./modules/k1-promotion/K1PromotionDetailModule";
import OwnerClaimModule from "./modules/owner/claim/OwnerClaimModule";
import ClaimRecordModule from "./modules/owner/claim/ClaimRecordModule";
import OwnerWinningDetailModule from "./modules/owner/winning/OwnerWinningDetailModule";
import CouponRedeem from "./modules/owner/CouponRedeem";
import PaymentModule from "./modules/payment/PaymentModule";
import WarehouseHistoryModule from "./modules/warehouse/WarehouseHistoryModule";
import WarehouseHistorySearchModule from "./modules/warehouse/WarehouseHistorySearchModule";
import WarehouseHistoryOldModule from "./modules/warehouse/WarehouseHistoryOldModule";
import MallMyBondModule from "./modules/mall/MallMyBondModule";
import ActivityDetailModule from "./modules/activity/ActivityDetailModule";
import GetCouponsModule from "./modules/get-coupons/GetCouponsModule";
import WarehouseExceptionModule from "./modules/warehouse/WarehouseExceptionModule";
import WarehouseStockModule from "./modules/warehouse/WarehouseStockModule";
import TaskDetailModule from "./modules/task-detail/TaskDetailModule";
import AnnualBillModule from "./modules/annual-bill/AnnualBillModule";
import ShopCheckModule from "./modules/shop-check/ShopCheckModule";
import K2AppealModule from "./modules/tbr-scan/K2AppealModule";
import TbrScanBaseModule from "./modules/tbr-scan/TbrScanBaseModule";
import K2OutInModule from "./modules/tbr-scan/K2OutInModule";
import WarrantyModule from "./modules/tbr-scan/WarrantyModule";

export const namespaceHelper = (ModuleClass: any) =>
  getModule(ModuleClass, store) &&
  // VuexModule 内置的私有属性
  namespace(ModuleClass._vmdModuleName);

// 原来的写法
export const AppStore = namespace("app");
export const PageStore = namespace("page");

// class的写法
// 秒杀
export const PromotionListStore = namespaceHelper(PromotionListModule);
export const PromotionDetailStore = namespaceHelper(PromotionDetailModule);
export const PromotionConfirmStore = namespaceHelper(PromotionConfirmModule);

// wt商城——小胎 PCR
export const MallProductListStore = namespaceHelper(MallProductListModule);
export const MallOrderListStore = namespaceHelper(MallOrderListModule);
export const MallOrderDetailStore = namespaceHelper(MallOrderDetailModule);
export const MallShoppingCartStore = namespaceHelper(MallShoppingCartModule);
export const MallAttributeStore = namespaceHelper(MallAttributeModule);
export const MallOrderConfirmStore = namespaceHelper(MallOrderConfirmModule);
export const MallActivityStore = namespaceHelper(MallActivityModule);
export const MallMyCouponStore = namespaceHelper(MallMyCouponModule);
export const PaymentStore = namespaceHelper(PaymentModule);

// 登录
export const UserStore = namespaceHelper(UserModule);

// 抽奖
export const DrawStore = namespaceHelper(DrawModule);

// 星级中心
export const StartLevelCenterStore = namespaceHelper(StartLevelCenterModule);
// 星级成长值
export const GrowthDetailStore = namespaceHelper(GrowthDetailModule);
// 奖励金
export const BountyDetailStore = namespaceHelper(BountyDetailModule);
// 积分
export const IntegralDetailStore = namespaceHelper(IntegralDetailModule);

// k1 促销
export const K1PromotionListStore = namespaceHelper(K1PromotionListModule);
export const K1PromotionDetailStore = namespaceHelper(K1PromotionDetailModule);

// 常规促销活动
export const ActivityDetailStore = namespaceHelper(ActivityDetailModule);

// 车主服务
export const OwnerClaimStore = namespaceHelper(OwnerClaimModule);
export const ClaimRecordStore = namespaceHelper(ClaimRecordModule);
export const OwnerWinningDetailStore = namespaceHelper(
  OwnerWinningDetailModule
);

export const CouponRedeemStore = namespaceHelper(CouponRedeem);

// 出入库

export const WarehouseExceptionStore = namespaceHelper(
  WarehouseExceptionModule
);
export const WarehouseStockStore = namespaceHelper(WarehouseStockModule);

// 实物券
export const MallMyBondStore = namespaceHelper(MallMyBondModule);

export const GetCouponsStore = namespaceHelper(GetCouponsModule);
//
export const TaskDetailStore = namespaceHelper(TaskDetailModule);

//
export const AnnualBillStore = namespaceHelper(AnnualBillModule);

// 店检管理
export const ShopCheckStore = namespaceHelper(ShopCheckModule);

//大胎扫码2026 - 申诉模块
export const TbrScanK2AppealStore = namespaceHelper(K2AppealModule);

export const TbrScanBaseModuleStore = namespaceHelper(TbrScanBaseModule);

export const K2OutInModuleStore = namespaceHelper(K2OutInModule);
export const TbrScanWarrantyStore = namespaceHelper(WarrantyModule);

export const WarehouseHistoryOldStore = namespaceHelper(
  WarehouseHistoryOldModule
);

export const WarehouseHistoryStore = namespaceHelper(WarehouseHistoryModule);
export const WarehouseHistorySearchStore = namespaceHelper(
  WarehouseHistorySearchModule
);
